// covered-by: frontends/carrie/src/ask-v2/pages/__tests__/AskV2ChatPage.test.tsx
// covered-by: frontends/carrie/src/ask-v2/pages/__tests__/AskV2ProjectPage.test.tsx
import { type ReactNode } from "react";

type AskV2ConversationShellProps = {
  testId: string;
  header?: ReactNode;
  tabs?: ReactNode;
  composer: ReactNode;
  rail?: ReactNode;
  children: ReactNode;
};

export function AskV2ConversationShell({
  testId,
  header,
  tabs,
  composer,
  rail,
  children,
}: AskV2ConversationShellProps) {
  return (
    <div
      data-testid={testId}
      className="ask-puntt-surface relative flex h-full min-h-0 min-w-0 flex-1 flex-col overflow-hidden"
    >
      {header}
      {tabs}
      <div className="flex min-h-0 flex-1 overflow-hidden">
        <div className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">
          <div
            className="flex-1 overflow-y-auto px-4 py-6"
            data-testid="ask-v2-messages"
          >
            <div className="mx-auto w-full max-w-[720px] space-y-4">
              {children}
            </div>
          </div>
          <div className="shrink-0 p-4" data-testid="ask-v2-composer-region">
            <div className="mx-auto w-full max-w-[720px]">{composer}</div>
          </div>
        </div>
        {rail}
      </div>
    </div>
  );
}
